import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Form, Image, Row } from 'react-bootstrap';
import { ErrorToast, SuccessToast, WarningToast } from '../../../utils/toasters';
import { CampaignsService } from '../CampaignsService';
import { ICreateCampaignGoal } from '../../../model/campaign/ICampaignsGoals';
import { useNavigate, useParams } from 'react-router-dom';
import { multipartFormData } from '../../../api/api.service';
import { CAMPAIGN_GOALS_URL } from '../../../utils/Endpoints';

export function CampaignGoalForm() {
    const [goal, setGoal] = useState<ICreateCampaignGoal>({
        title: '',
        story: '',
        storyGerman: '',
        summary: '',
        summaryGerman: '',
        isActive: false,
    });
    const { goalId } = useParams();
    const [selectedFile, setSelectedFile] = useState(null);
    const [imagePath, setImage] = useState('');
    const [check, setCheck] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        if (goalId) {
            CampaignsService.getCampaignGoal(+goalId)
                .then(response => {
                    setGoal(response);
                    if (response?.goalImage) {
                        setImage(response?.goalImage?.path);
                    }
                    setCheck(response.isActive);
                })
                .catch(err => ErrorToast(err));
        }
    }, []);

    useEffect(() => {
        setGoal({ ...goal, isActive: check });
    }, [check]);

    const createCampaignGoal = () => {
        if (
            goal.title !== '' &&
            goal.summary !== '' &&
            goal.summaryGerman !== '' &&
            goal.story !== '' &&
            goal.storyGerman !== ''
        ) {
            multipartFormData(selectedFile, CAMPAIGN_GOALS_URL, JSON.stringify(goal), 'post')
                .then(() => {
                    SuccessToast('Successfully created campaign goal');
                    navigate('/campaign/goals');
                })
                .catch(error => ErrorToast(error));
        } else {
            WarningToast('Please fill out all mandatory fields');
        }
    };

    const updateCampaignGoal = () => {
        multipartFormData(selectedFile, `${CAMPAIGN_GOALS_URL}/${goalId}`, JSON.stringify(goal))
            .then(() => {
                SuccessToast('Successfully updated campaign goal');
                navigate('/campaign/goals');
            })
            .catch(error => ErrorToast(error));
    };

    function handleChange(event: any) {
        const value = event.target.value;
        setGoal({
            ...goal,
            [event.target.name]: value,
        });
    }

    function handleFileInput(evt: any) {
        if (evt.target.files.length > 0) {
            setSelectedFile(evt.target.files[0]);
            setImage(URL.createObjectURL(evt.target.files[0]));
        }
    }

    return (
        <Card className="mb-5">
            <Form as={Card.Body}>
                <h3>{goalId ? 'Update goal' : 'Create goal'}</h3>
                <hr />
                <Row>
                    <Col md={8}>
                        <Form.Group>
                            <Form.Label className="required">Title</Form.Label>
                            <Form.Control name="title" onChange={handleChange} defaultValue={goal.title} />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label className="required">Summary English</Form.Label>
                            <Form.Control
                                as="textarea"
                                maxLength={255}
                                name="summary"
                                onChange={handleChange}
                                defaultValue={goal.summary}
                            />
                        </Form.Group>

                        <Form.Group>
                            <Form.Label className="required">Summary German</Form.Label>

                            <Form.Control
                                as="textarea"
                                maxLength={255}
                                name="summaryGerman"
                                onChange={handleChange}
                                defaultValue={goal.summaryGerman}
                            />
                        </Form.Group>

                        <Form.Group>
                            <Form.Label className="required">Story English</Form.Label>
                            <Form.Control
                                as="textarea"
                                maxLength={255}
                                name="story"
                                onChange={handleChange}
                                defaultValue={goal.story}
                            />
                        </Form.Group>

                        <Form.Group>
                            <Form.Label className="required">Story German</Form.Label>

                            <Form.Control
                                as="textarea"
                                maxLength={255}
                                name="storyGerman"
                                onChange={handleChange}
                                defaultValue={goal.storyGerman}
                            />
                        </Form.Group>

                        <Form.Group>
                            <Form.Check
                                label="active"
                                name="active"
                                onChange={() => setCheck(!check)}
                                checked={check}
                            />
                        </Form.Group>
                    </Col>

                    <Col md={4}>
                        <Form.Group>
                            <Form.Label>Upload photo</Form.Label>
                            <Form.Control accept=".jpg, .jpeg, .png" type="file" onChange={handleFileInput} />
                            {imagePath && (
                                <Image
                                    className="mt-3 img-cover"
                                    width={300}
                                    height={250}
                                    alt={imagePath}
                                    src={imagePath}
                                />
                            )}
                        </Form.Group>
                    </Col>
                </Row>
                <Button
                    onClick={goalId ? updateCampaignGoal : createCampaignGoal}
                    className="col-md-1 col-sm-12"
                    size="lg"
                >
                    Save
                </Button>
            </Form>
        </Card>
    );
}
